import { promptToCopywriterMessages } from '$lib/ai/post/utils/promptToCopywriterMessages';
import type { AssistantClient } from '$lib/types/AssistantClient';

export const sendPromptToAssistant = async (prompt: string, assistantClient: AssistantClient) => {
	await assistantClient.sendMessage(promptToCopywriterMessages(prompt));
};
